module.exports = __webpack_public_path__ + "static/lenvima-chart-desktop-faa59532a301c741e0ae14786ee44630.png";